import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { suggestionsApi } from '@/services/api/suggestions'

export function useSuggestions() {
  return useQuery({
    queryKey: ['admin', 'suggestions'],
    queryFn: suggestionsApi.list,
    staleTime: 60_000, // 1 minute - avoid unnecessary refetches
  })
}

export function useCleanupOrphanedSuggestions() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: suggestionsApi.cleanupOrphaned,
    onSuccess: () => {
      // Invalidate suggestions list to refresh the data
      queryClient.invalidateQueries({ queryKey: ['admin', 'suggestions'] })
    },
  })
}

/**
 * Lazy mutation for exporting suggestions as CSV.
 * Call `mutateAsync()` to trigger the export fetch; the returned data
 * includes performance history enriched from the concert archive.
 */
export function useExportSuggestions() {
  return useMutation({
    mutationFn: suggestionsApi.exportForCsv,
  })
}
